import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {DefaultPropertyTypeFilters} from "../model/filters/default-property-type-filters";
import {DefaultPropertyTypePersistRequest} from "../model/requests/default-property-type-persist-request";

@Injectable({
  providedIn: 'root'
})
export class DefaultPropertyTypesService {

  private readonly defaultPropertyTypesURL: string;

  constructor(private http: HttpClient) {
    this.defaultPropertyTypesURL = '/catalog/default_property_types';
  }

  public getDefaultPropertyTypes(offset?: number, limit?: number, filters?: DefaultPropertyTypeFilters): Observable<any> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new DefaultPropertyTypeFilters();
    return this.http.post<any>(this.defaultPropertyTypesURL, body, options);
  }

  public getDefaultPropertyType(name: string, unit: string): Observable<any> {
    const url = `${this.defaultPropertyTypesURL}/${name}/${unit}`;
    return this.http.get<any>(url);
  }

  public createDefaultPropertyType(defaultPropertyTypePersistRequest: DefaultPropertyTypePersistRequest): Observable<void> {
    const url = `${this.defaultPropertyTypesURL}/create`;
    return this.http.post<void>(url, defaultPropertyTypePersistRequest);
  }

  public editDefaultPropertyType(defaultPropertyTypePersistRequest: DefaultPropertyTypePersistRequest): Observable<void> {
    const url = `${this.defaultPropertyTypesURL}/edit`;
    return this.http.post<void>(url, defaultPropertyTypePersistRequest);
  }

  public deleteDefaultPropertyType(name: string, unit: string): Observable<HttpResponse<any>> {
    const url = `${this.defaultPropertyTypesURL}/${name}/${unit}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteDefaultPropertyTypes(identifiers: { name: string, unit: string }[]): Observable<void> {
    const url = `${this.defaultPropertyTypesURL}/delete`;
    return this.http.post<void>(url, identifiers);
  }
}
